<script setup lang="ts">
import { defineEmits } from 'vue'

const emit = defineEmits(['back-to-project', 'back-to-form'])
</script>

<template>
  <v-card class="text-center" variant="text">
    <v-icon color="error" size="44"> mdi-information-outline</v-icon>
    <v-card-text class="text-h6 pb-0"> Apologies, there is a server error.</v-card-text>
    <v-card-text class="text-h6 pt-0">
      Please go back to your calculation and run it again.
    </v-card-text>
    <v-btn elevation="0" class="text-none" @click="emit('back-to-form')">
      Return to the calculation
    </v-btn>
  </v-card>
</template>
